import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const ChatSurvey = gql`
  query ChatSurvey($input: SurveyInput!) {
    survey(input: $input) {
      __typename
      ... on SurveyError {
        __typename
        ...error
      }
      ... on SurveySuccess {
        questions {
          ... on StarRatingSurveyQuestion {
            __typename
            id
            title
            options {
              id
              title
              value
            }
          }
          ... on ThumbsUpOrDownSurveyQuestion {
            __typename
            id
            title
            thumbsUpOption {
              id
              title
              value
            }
            thumbsDownOption {
              id
              title
              value
            }
          }
        }
      }
    }
  }
  ${error}
`;

export default ChatSurvey;
